import { useState } from "react";
import { ChevronDown } from "lucide-react";

type Item = { q: string; a: string };

const items: Item[] = [
  {
    q: "What does the free mini-audit include?",
    a: "A short read of your landing or product page covering 3 friction signals our analysts flag most often — usability, clarity, and trust.",
  },
  {
    q: "What's the difference between mini and full audit?",
    a: "The mini audit is a quick directional scan. The full audit covers 30+ heuristics, ties findings to behavioural data, and ships with a prioritized A/B test backlog.",
  },
  {
    q: "How long does the full audit take?",
    a: "We deliver the full audit within 48 hours of payment, reviewed by a senior CRO consultant before it lands in your inbox.",
  },
  {
    q: "Do you offer refunds?",
    a: "Yes. If the full audit doesn't meet the standard described on this page, email us within 7 days and we'll refund in full.",
  },
  {
    q: "Is this run by a human or AI?",
    a: "Hybrid. Automated analysis surfaces patterns at scale; a senior CRO consultant reviews and signs off every audit before delivery.",
  },
];

export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <div className="divide-y divide-[color:hsl(var(--border))] border-y border-[color:hsl(var(--border))]">
      {items.map((it, i) => {
        const isOpen = open === i;
        return (
          <div key={i}>
            <button
              className="flex w-full items-center justify-between gap-6 py-5 text-left"
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
            >
              <span className="text-[16px] font-medium text-white">{it.q}</span>
              <ChevronDown
                size={18}
                className="shrink-0 text-[color:hsl(var(--muted-foreground))] transition-transform"
                style={{ transform: isOpen ? "rotate(180deg)" : "none" }}
              />
            </button>
            {isOpen && (
              <p className="pb-5 pr-10 text-[15px] text-[color:hsl(var(--muted-foreground))] fade-in">
                {it.a}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}
